(function () {
    'use strict';

    a3_cabin_reports.directive('misconnectionFlightsPanel', misconnectionFlightsPanel);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name misconnectionFlightsPanel
    * @restrict E
    * @description
    *   Implementation of misconnectionFlights panel
    * @example
    *   Usage:
    *   <misconnection-flights-panel></misconnection-flights-panel>
    * @ngInject
    */
    function misconnectionFlightsPanel ( MisconnectionFlightsFactory, PaxInfoFactory, defaultCalendarDate) {
        function link(scope,  element, attributes) {
            scope.showMisconnectionFlightsPanel = false;
            scope.preparedFlights = []; 
            scope.getDisplayETD = getDisplayETD;
            scope.calcConnection = calcConnection;
            scope.hasAnyEscort = false;
            scope.hasAnyReprotection = false;   
            //scope.paxInfo;

            // This directive can render on routes where no flight object exists.
            if (!scope.flight || !scope.flight.FlightId) {
                return;
            }

            var currentFlightId = null;
            //get from LS the misconnection flights
             if (defaultCalendarDate && scope.flight && scope.flight.FlightId == 1226541) {
                currentFlightId = 2242084; //<=(747 17-6-2016) 
            } else{
                currentFlightId = scope.flight ? scope.flight.FlightId : null;
            }

            getMisconnectionFlights(currentFlightId);
            
            //get misconnection flights by flight id from LS and prepare data for the panel
            function getMisconnectionFlights(flightId) {
                var misconnectionFlights = MisconnectionFlightsFactory.getMisconnectionFlightsByFlightIdFromLS(flightId);
                prepareMisconnectionTable (misconnectionFlights);
                scope.showMisconnectionFlightsPanel = true;
            } 

            //prepare data for the misconnection flights panel
            function prepareMisconnectionTable(misconnectionFlights) {

                let flightsWithActions = [];
                let connectingFlights = [];
                let preparedFlights = [];

                PaxInfoFactory.getPaxInfoFromStorage(scope.flight.FlightId, function (paxInfo) {
                    if (paxInfo) {
                        connectingFlights = paxInfo.ConnectingFlights || [];
                
                        misconnectionFlights.forEach(disrupted => {
                            let allActions = [];
                            
                            disrupted.Passengers.forEach(p => {
                                // Find STD and FlightNumber from THIS passenger's action with FlightOccurrenceOrder == 0
                                var sortBySTD = null;
                                var parentFlightNumber = null;
                                var action0 = p.Actions.find(function(action) { 
                                    return action.FlightOccurrenceOrder === 0; 
                                });
                                if (action0) {
                                    sortBySTD = action0.STD;
                                    parentFlightNumber = action0.FlightNumber;
                                }
                                
                                p.Actions.forEach(a => {
                                    allActions.push({
                                        ...a,
                                        UCI: p.UCI,
                                        sortBySTD: sortBySTD,
                                        parentFlightNumber: parentFlightNumber
                                    });
                                });

                            });
                            
                            // Group by FlightNumber + FlightDate + ParentFlightNumber
                            let grouped = {};
                            allActions.forEach(function(a) {

                                var groupKey = (a.parentFlightNumber || '') + '_' + a.FlightNumber + a.FlightDate + '_' + a.HasReprotectedAction;
                                if (!grouped[groupKey]) {
                                    grouped[groupKey] = {
                                        flight: a,
                                        pax: [],
                                        hasReprotectedAction: false,
                                        hasEscortAction:  false,
                                        sortBySTD: a.sortBySTD,
                                        parentFlightNumber: a.parentFlightNumber
                                    };
                                }
                                grouped[groupKey].pax.push({ UCI: a.UCI });
                                grouped[groupKey].hasReprotectedAction = grouped[groupKey].hasReprotectedAction || a.HasReprotectedAction;
                                grouped[groupKey].hasEscortAction = grouped[groupKey].hasEscortAction || a.HasEscortAction;
                            });

                            // Sort flights by Order and map to final structure
                            var sortedFlights = Object.keys(grouped).map(function(key) {
                                var x = grouped[key];
                                
                                // Calculate passenger summaries from the grouped actions
                                var passengerSummaryC = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                var passengerSummaryY = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                
                                // Find all matching actions for this flight to get cabin class info
                                allActions.forEach(function(action) {
                                    if (action.FlightNumber === x.flight.FlightNumber && 
                                        action.FlightDate === x.flight.FlightDate &&
                                        action.FlightOccurrenceOrder === x.flight.FlightOccurrenceOrder &&
                                        action.HasReprotectedAction === x.hasReprotectedAction) {
                                        
                                        if (action.CabinClass === 'C') {
                                            passengerSummaryC.Passengers++;
                                            if (action.HasPRM) passengerSummaryC.PRM++;
                                            if (action.HasUMNR) passengerSummaryC.UMNR++;
                                            if (action.HasDEP) passengerSummaryC.DEP++;
                                        } else if (action.CabinClass === 'Y') {
                                            passengerSummaryY.Passengers++;
                                            if (action.HasPRM) passengerSummaryY.PRM++;
                                            if (action.HasUMNR) passengerSummaryY.UMNR++;
                                            if (action.HasDEP) passengerSummaryY.DEP++;
                                        }
                                    }
                                });
                                
                                return {
                                    FlightNumber: x.flight.FlightNumber,
                                    FlightDate: x.flight.FlightDate,
                                    Departure: x.flight.Departure,
                                    Arrival: x.flight.Arrival,
                                    STD: x.flight.STD,
                                    Gate: x.flight.Dep_Gate,
                                    Order: x.flight.FlightOccurrenceOrder,
                                    Pax: x.pax.length,
                                    HasReprotectedAction: x.hasReprotectedAction,
                                    HasEscortAction: x.hasEscortAction,
                                    ActionTimestamp: x.flight.ActionTimestamp,
                                    SortBySTD: x.sortBySTD,
                                    ParentFlightNumber: x.parentFlightNumber,
                                    PassengerSummaryC: passengerSummaryC,
                                    PassengerSummaryY: passengerSummaryY
                                };
                            }).sort(function(a, b) { return a.Order - b.Order; });

                            var prevETA = null;
                            // Calculate connection times
                            sortedFlights.forEach(f => {
                                if(f.Order === 0 || f.Order === 1){
                                    //scope value from user settings
                                    prevETA = scope.flightETA;
                                }
                                f.Connection = calcConnection(f.STD, prevETA);
                                let currentETA = new Date(f.STA);
                                if (f.ETA) {    
                                    currentETA = new Date(f.ETA);
                                }
                                prevETA = currentETA;
                            });

                            // Add to flightsWithActions
                            sortedFlights.forEach(f => 
                                flightsWithActions.push({
                                DisruptedFlightId: disrupted.DisruptedFlightId,
                                Connection: f.Connection,
                                FlightNo: f.FlightNumber,
                                FlightDate: f.FlightDate,
                                Departure: f.Departure,
                                Arrival: f.Arrival,
                                Pax: f.Pax, // FIX: Removed conditional - keep actual pax count
                                DepartureGate: f.Gate,
                                ETD: f.STD,
                                STD: f.STD, // FIX: Added STD for getDisplayETD function
                                Order: f.Order,
                                HasReprotection: f.HasReprotectedAction,
                                HasEscort: f.HasEscortAction,
                                MatchChecked: false,
                                PaxCounter: f.Pax,
                                ActionTimestamp: f.ActionTimestamp,
                                SortBySTD: f.SortBySTD,
                                ParentFlightNumber: f.ParentFlightNumber,
                                PassengerSummaryC: f.PassengerSummaryC,
                                PassengerSummaryY: f.PassengerSummaryY
                            }));
                        });

                        //Sort by ActionTimestamp 
                        flightsWithActions = flightsWithActions.sort((a, b) => new Date(a.ActionTimestamp) - new Date(b.ActionTimestamp));

                        // Match connecting flights with actions
                        connectingFlights.forEach(connFlight => {
                            let matchedFlights = flightsWithActions.filter(f =>
                                f.FlightNo === connFlight.FlightNo &&
                                f.FlightDate === connFlight.FlightDate &&
                                f.Departure === connFlight.Departure && 
                                //f.HasReprotection === connFlight.HasReprotection &&
                                //f.HasEscort === connFlight.HasEscort &&
                                f.Order === 1);

                            if (matchedFlights.length > 0) {
                                    // YES: apply flags and mark as matched
                                    matchedFlights.forEach(matchedFlight => {
                                        matchedFlight.MatchChecked = true;
                                        // Save the action summaries before overwriting
                                        matchedFlight.ActionSummaryC = JSON.parse(JSON.stringify(matchedFlight.PassengerSummaryC));
                                        matchedFlight.ActionSummaryY = JSON.parse(JSON.stringify(matchedFlight.PassengerSummaryY));
                                        matchedFlight.PaxCounter = (connFlight.PassengerSummaryC.Passengers || 0) + (connFlight.PassengerSummaryY.Passengers || 0); 
                                        matchedFlight.PassengerSummaryC = connFlight.PassengerSummaryC;
                                        matchedFlight.PassengerSummaryY = connFlight.PassengerSummaryY;  
                                    });
                            } else{
                                // NO: create a new entry for unmatched connecting flight
                                var tempFlight = {
                                    FlightNo: connFlight.FlightNo,
                                    FlightDate: connFlight.FlightDate,
                                    Departure: connFlight.Departure,
                                    Arrival: connFlight.Arrival,
                                    ETD: connFlight.ETD,
                                    STD: connFlight.STD, 
                                    DepartureGate: connFlight.Dep_Gate,
                                    Order: 0,
                                    HasReprotection: false,
                                    HasEscort: connFlight.HasEscort, //false,
                                    Connection: calcConnection(connFlight.STD, scope.flightETA),
                                    PassengerSummaryC: connFlight.PassengerSummaryC,
                                    PassengerSummaryY: connFlight.PassengerSummaryY,
                                    MatchChecked: false,
                                    PaxCounter: connFlight.PassengerIds.length,
                                    SortBySTD: connFlight.STD || connFlight.ETD,
                                    ParentFlightNumber: connFlight.FlightNo
                                };
                                preparedFlights.push(tempFlight);
                            }
                        });

                        // Add flights from flightsWithActions
                        flightsWithActions.forEach(f => {
                            var isNewAction = IsNewAction(f.ActionTimestamp, scope.flight.ScheduledDeparture);
                            f.IsNewAction = isNewAction;

                            if(!f.PassengerSummaryC){
                                f.PassengerSummaryC = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                            }
                            if(!f.PassengerSummaryY){
                                f.PassengerSummaryY = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                            }

                            if ( f.Order <= 1 && isNewAction  ) {

                                // paxCounter: all pax, Pax: pax from paxInfo (simple connections)
                                if(f.MatchChecked && f.PaxCounter != f.Pax){

                                    // Find all matched actions for the same flight, get sums of their passengers.
                                    var matchedFlights = flightsWithActions.filter(mf =>
                                        mf.FlightNo === f.FlightNo &&
                                        mf.FlightDate === f.FlightDate &&
                                        mf.Departure === f.Departure && 
                                        mf.MatchChecked === true);

                                    var totalActionSummaryC = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                    var totalActionSummaryY = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };

                                        // Sum up all ActionSummaries from matched flights
                                    matchedFlights.forEach(function(mf) {
                                        if (mf.ActionSummaryC) {
                                            totalActionSummaryC.Passengers += mf.ActionSummaryC.Passengers || 0;
                                            totalActionSummaryC.PRM += mf.ActionSummaryC.PRM || 0;
                                            totalActionSummaryC.UMNR += mf.ActionSummaryC.UMNR || 0;
                                            totalActionSummaryC.DEP += mf.ActionSummaryC.DEP || 0;
                                        }
                                        if (mf.ActionSummaryY) {
                                            totalActionSummaryY.Passengers += mf.ActionSummaryY.Passengers || 0;
                                            totalActionSummaryY.PRM += mf.ActionSummaryY.PRM || 0;
                                            totalActionSummaryY.UMNR += mf.ActionSummaryY.UMNR || 0;
                                            totalActionSummaryY.DEP += mf.ActionSummaryY.DEP || 0;
                                        }
                                    });

                                    var simplePaxC = {
                                        Passengers: (f.PassengerSummaryC.Passengers || 0) - totalActionSummaryC.Passengers,
                                        PRM: (f.PassengerSummaryC.PRM || 0) - totalActionSummaryC.PRM,
                                        UMNR: (f.PassengerSummaryC.UMNR || 0) - totalActionSummaryC.UMNR,
                                        DEP: (f.PassengerSummaryC.DEP || 0) - totalActionSummaryC.DEP
                                    };
                                    var simplePaxY = {
                                        Passengers: (f.PassengerSummaryY.Passengers || 0) - totalActionSummaryY.Passengers,
                                        PRM: (f.PassengerSummaryY.PRM || 0) - totalActionSummaryY.PRM,
                                        UMNR: (f.PassengerSummaryY.UMNR || 0) - totalActionSummaryY.UMNR,
                                        DEP: (f.PassengerSummaryY.DEP || 0) - totalActionSummaryY.DEP
                                    };

                                    var tempFlight = {
                                        FlightNo: f.FlightNo,
                                        Departure: f.Departure,
                                        Arrival: f.Arrival,
                                        ETD: f.ETD,
                                        STD: f.STD, 
                                        DepartureGate: f.Dep_Gate,
                                        Order: 0,
                                        HasReprotection: false,
                                        HasEscort: f.HasEscort, //false,
                                        Connection: calcConnection(f.STD, scope.flightETA),
                                        PassengerSummaryC: simplePaxC,
                                        PassengerSummaryY: simplePaxY,
                                        MatchChecked: true,
                                        PaxCounter: simplePaxC.Passengers + simplePaxY.Passengers,
                                        
                                        //Order:0 sortSTD and parent from current flight
                                        SortBySTD: f.ETD || f.STD,
                                        ParentFlightNumber: f.FlightNo
                                    };
                                    //check if already added the flight:
                                    var alreadyAdded = preparedFlights.some(pf => 
                                        pf.FlightNo === tempFlight.FlightNo &&
                                        (pf.STD === tempFlight.STD || pf.ETD === tempFlight.ETD) &&
                                        pf.Departure === tempFlight.Departure &&
                                        pf.PaxCounter === tempFlight.PaxCounter &&
                                        pf.Order === 0);

                                    // Only add to preparedFlights if there are passengers after adjusting for reprotection actions
                                    if(tempFlight.PaxCounter > 0 && !alreadyAdded && !f.HasEscort){

                                        preparedFlights.push(tempFlight);
                                    }

                                    //Add flight with reprotections (use action summaries)
                                    f.PassengerSummaryC = f.ActionSummaryC || { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                    f.PassengerSummaryY = f.ActionSummaryY || { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                    f.PaxCounter = f.HasEscort ? f.PaxCounter : f.Pax || 0;

                                    preparedFlights.push(f);

                                }else{
                                    var currentPaxCounter = 0;

                                    if(f.PassengerSummaryC && f.PassengerSummaryY){
                                        currentPaxCounter = (f.PassengerSummaryC.Passengers || 0) + (f.PassengerSummaryY.Passengers || 0);
                                    }
                                    else{
                                        currentPaxCounter = f.Pax;
                                    }
                                    f.PaxCounter = currentPaxCounter;

                                    //set pax counters to 0
                                    if(f.HasReprotection && f.Order === 0){
                                        f.PaxCounter = 0;
                                        f.PassengerSummaryC = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                        f.PassengerSummaryY = { Passengers: 0, PRM: 0, UMNR: 0, DEP: 0 };
                                    }

                                    preparedFlights.push(f);
                                }
                            }else if(f.Order == 1 && !isNewAction ){
                                //if is old action, just show the connecting flight with no reprotection color, no canceled flight and without padding
                                f.Order = 0;
                                f.HasReprotection = false;

                                preparedFlights.push(f);
                            }
                        });    
                        
                        // Set flags for panel legend
                        scope.hasAnyEscort = preparedFlights.some(f => f.HasEscort);
                        scope.hasAnyReprotection = preparedFlights.some(f => f.HasReprotection && f.IsNewAction);

                        // Sort preparedFlights: first by SortBySTD, then by ParentFlightNumber, then by actual STD, then by Order desc
                        scope.preparedFlights = preparedFlights.sort(function(a, b) {
                            // First sort by SortBySTD (handle null/undefined - use STD as fallback)
                            var stdA = a.SortBySTD ? new Date(a.SortBySTD).getTime() : (a.STD ? new Date(a.STD).getTime() : 0);
                            var stdB = b.SortBySTD ? new Date(b.SortBySTD).getTime() : (b.STD ? new Date(b.STD).getTime() : 0);
                            
                            if (stdA !== stdB) {
                                return stdA - stdB;
                            }
                            
                            // If SortBySTD is equal, sort by ParentFlightNumber
                            var parentA = a.ParentFlightNumber || '';
                            var parentB = b.ParentFlightNumber || '';
                            
                            if (parentA !== parentB) {
                                return parentA.localeCompare(parentB);
                            }
                            
                            // If ParentFlightNumber is equal, sort by actual flight time (ETD or STD)
                            var departureTimeA = a.ETD ? new Date(a.ETD).getTime() : (a.STD ? new Date(a.STD).getTime() : 0);
                            var departureTimeB = b.ETD ? new Date(b.ETD).getTime() : (b.STD ? new Date(b.STD).getTime() : 0);
                            
                            if (departureTimeA !== departureTimeB) {
                                return departureTimeA - departureTimeB;
                            }
                            
                            // If actual STD is also equal, sort by Order desc (1 first, then 0)
                            var orderA = a.Order || 0;
                            var orderB = b.Order || 0;
                            
                            return orderB - orderA;
                        });
                    }
                });
            }

            //check if the action is new (within 60 minutes before flight STD)
            function IsNewAction(actionTimestamp, flightSTD) {
//return true; //only for the tests
                if (defaultCalendarDate && scope.flight.FlightId == 1226541) {
                    console.log('opa!');
                    return true; //always new for test flight
                }
                var isNew = false;
                var std = new Date(flightSTD);
                var ts = new Date(actionTimestamp);
                if (isNaN(std.getTime()) || isNaN(ts.getTime())) {
                    return isNew;
                }
                var diffMinutes = (std.getTime() - ts.getTime()) / 60000;
                if (diffMinutes <= 60) {
                    isNew = true;
                }

                return isNew;
            }

            scope.$watch('flightETA', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    reCalculateConnections(newValue);
                }
            });

            function reCalculateConnections(newTempETA) {
                var prevETA = null;
                // Calculate connection times
                scope.preparedFlights.forEach(f => {
                    if(f.Order === 0 || f.Order === 1){
                        //scope value from user settings
                        prevETA = scope.flightETA;
                    }
                    f.Connection = calcConnection(f.STD, newTempETA);
                    let currentETA = new Date(f.STA);
                    if (f.ETA) {    
                        currentETA = new Date(f.ETA);
                    }
                    prevETA = currentETA;
                });
            }

            //calculate connection time between disrupted flight and connecting flight
            function calcConnection(currentSTD, prevETA) {
                var timeString = '';
                var sign = '';
                var dayString = null;

                if (currentSTD) {
                    var connFlightDate = new Date(currentSTD);
                    var ms = connFlightDate.getTime() - prevETA; // this is a time in milliseconds
                    if (ms < 0) {
                        ms = -ms;
                        sign = "-";
                    }
                    var days = Math.floor(ms / (24 * 60 * 60 * 1000));
                    days = days < 0 ? days + 1 : days;
                    var daysms = ms % (24 * 60 * 60 * 1000);
                    var hours = Math.floor((daysms) / (60 * 60 * 1000));
                    var hoursms = ms % (60 * 60 * 1000);
                    var minutes = Math.floor((hoursms) / (60 * 1000));
                    timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
                    dayString = ' <span class="badge">' + days + 'd</span>';
                }
                return timeString + ((days && days != 0) ? dayString : '');
            }

            /**
             * Returns the ETD for the flight
             * @memberof misconnectionFlightsPanel
             * @param {object} connFlight The connection flight object
             * @return {string} ETD string
             */
            function getDisplayETD(connFlight) {
                // Default prefix 
                var prefix = "S";
                var timeToShow = connFlight.STD;

                // If ATD is available, use this
                if (connFlight.ATD) {
                    prefix = "A";
                    timeToShow = connFlight.ATD;
                }
                // If ETD is available, use that
                else if (connFlight.ETD) {
                    prefix = "E";
                    timeToShow = connFlight.ETD;
                }

                var timeString = " - ";
                if(timeToShow){
                    timeString = moment(timeToShow).format("HH:mm");
                }

                var delay = "";

                // Calculate delay only if ATD or ETD is available
                var actualTime = connFlight.ATD || connFlight.ETD;
                if (actualTime && connFlight.STD) {
                    var actualTime = new Date(actualTime).getTime();
                    var std = new Date(connFlight.STD).getTime();
                    var diff = actualTime - std;

                    // Only show delay if it's not zero
                    var diffMinutes = Math.floor(diff / 60000);
                    if (diffMinutes !== 0) {
                        var sign = diffMinutes > 0 ? "+" : "";
                        delay = "(" + sign + diffMinutes + ")";
                    }
                }

                // Return full string
                // return prefix + ' <strong>' + timeString + '</strong>' + delay;
                return {
                    prefix: prefix,
                    time: timeString,
                    delay: delay
                };
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/MisconnectionFlights/misconnectionFlightsPanel.tpl.html',
            scope: false,
            link: link
        }
    }

})();
